<template>
    <div v-loading="dataLoading">
        <el-card>
            <template v-if="data">
                <el-link :href="`${sswap}/pages/activity/detail/detail?activityId=${data.activityId}`" target="_blank" type="primary">{{ data.title
                }}</el-link>
				<div slot="header">
					<span>定向计划基础信息</span>
				</div>
                <el-row :gutter="20">
                    <el-col :sm="12" :md="8" class="MT10">
                        <span class="color-info">计划ID: </span>{{data.cpsId}}	
                    </el-col>
                    <el-col :sm="12" :md="8" class="MT10">
                        <span class="color-info">计划名称: </span>{{data.cpsName}}
                    </el-col>
                    <el-col :sm="12" :md="8" class="MT10">
                        <span class="color-info">计划联系人手机号: </span>{{data.telephone}}		
                    </el-col>
                    <el-col :sm="12" :md="8" class="MT10">
                       <label class="color-info">计划状态：</label>{{ status[data.status] }}
                       <!-- <el-button v-if="data.status != 3" type="text" icon="el-icon-edit" size="small" @click="$refs.statusEdit.show(data)">修改状态</el-button> -->
                    </el-col>
                    <el-col :sm="12" :md="8" class="MT10">
                        <span class="color-info">计划类型: </span>{{ contentType[data.contentType] }}		 
                    </el-col>
                    <el-col :sm="12" :md="8" class="MT10" v-if="data.contentType == 1 ">
                        <span class="color-info">佣金有效期: </span>{{data.expirationDate}}天
                    </el-col>
					<el-col :sm="24" class="MT10" v-if="data.contentType == 1 ">
					    <span class="color-info">上传投稿短视频时间段:  </span>{{data.startTime}}	 - {{data.endTime}}
					</el-col>
                </el-row>
            </template>
        </el-card>
        <el-card class="MT20">
            <div slot="header">
                <span>当前计划汇总数据</span>
				<div v-if="data && data.cutOffDate">
				    数据更新时间：{{data.cutOffDate}}
				</div>
            </div>
            <template v-if="data">
				<el-row :gutter="20">
				    <el-col :sm="12" :md="8" class="MT10">
				        <span class="color-info">带货销售额: </span>{{data.gmv}}
				    </el-col>
				    <el-col :sm="12" :md="8" class="MT10">
				        <span class="color-info">达人佣金: </span>{{data.talentCommission}}			
				    </el-col>
				    <el-col :sm="12" :md="8" class="MT10">
				       <span class="color-info">已核销订单金额: </span>{{data.usedGmv}}	
				    </el-col>
				    <el-col :sm="12" :md="8" class="MT10">
				       <span class="color-info">演出数: </span>{{ data.activityList.length }} 
				    </el-col>
				    <el-col :sm="12" :md="8" class="MT10">
				        <span class="color-info"> 达人数: </span>{{data.talentNum}}			
				    </el-col>
				    <el-col :sm="12" :md="8" class="MT10">
				        <span class="color-info">投稿数(包括短视频和直播): </span>{{data.mediaNum}}		 
				    </el-col>
				</el-row>
            </template>
        </el-card>        
        <el-card shadow="never" v-if="data && data.activityList" class="MT20">
			<div slot="header">
			    <span>商品列表</span>			    
			</div>
		  <el-table :data="data.activityList" border style="width: 100%" size="small" stripe>
			   <el-table-column prop="activityId" label="演出ID" show-overflow-tooltip></el-table-column>
			   <el-table-column prop="title" label="演出名称"></el-table-column>
			   <el-table-column prop="douyinPoiId" label="抖音ID"></el-table-column>
			   <el-table-column prop="ratio" label="佣金比例">
				   <template slot-scope="scope">
					   {{scope.row.ratio}}%
					</template>
			   </el-table-column>
		   </el-table>
        </el-card>
		<el-card class="MT20">
			<div slot="header">
			    <span>邀请的达人<small> <span class="color-warning ML10">修改计划, 可以删除多个达人或者添加达人</span></small></span>
			    
			</div>
		  <div class="douyinUserList">
			  <ul v-if="data && data.douyinUserIds">
				  <li v-for="item in data.douyinUserIds" >{{item}}</li>
			  </ul>
		  </div>
		</el-card>
        <el-card class="MT20">
            <div slot="header">
                <span>达人数据</span>
            </div>
            
            <div class="page-list-box" v-if="userData">
                <el-table :data="userData.result" border style="width: 100%" size="small" stripe>
                    <el-table-column prop="douyinId" label="达人抖音ID"></el-table-column>
					<el-table-column prop="status" label="带货状态">
						<template slot-scope="{row} = scope">
							{{status[row.status]}}
						</template>
					</el-table-column>				  
                  <el-table-column prop="gmv" label="带货总销售额"></el-table-column>
				  <el-table-column prop="talentCommission" label="带货总佣金"></el-table-column>
				  <el-table-column prop="usedGmv" label="已核销GMV"></el-table-column>
				  <el-table-column prop="contributeNum" label="作品数"></el-table-column>
				  <el-table-column prop="playNum" label="作品总观看量"></el-table-column>
				  <el-table-column prop="cutOffDate" label="累计截止日期"></el-table-column>
                  <el-table-column fixed="right" label="操作" mim-width="200">
					<template slot-scope="scope">
						<el-button
							v-if="$utils.have('/activity/cps/userDetailList')"
							type="text"
							size="small"
							@click="$refs.userDetailList.show(id,scope.row)"
							>查看详细数据</el-button
						>
					   <el-button
						  v-if="$utils.have('/activity/cps/userDetailList') && scope.row.status == 1"
						  type="text"
						  size="small"
						  @click="cancelUser(scope.row.douyinId)"
						  >取消达人</el-button
					   >
					</template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="userData" class="page-pagination-box">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="getUserList"
                    :current-page.sync="params.pageNo"
                    :page-sizes="$pageSizes"
                    :page-size.sync="params.pageSize"
                    layout="total, sizes, prev, pager, next"
                    :total="userData.totalCount || 0">
                </el-pagination>
            </div>
        </el-card>		
		<div class="page-btns-box MT20">
			<el-button
				v-if="$utils.have('/activity/cps/oriented/downloadDetail')"
				type="primary"
				icon="el-icon-download"
				@click="download"
				size="small"
				:loading="downLoading">导出详细数据</el-button>
			<el-button type="primary" icon="el-icon-update" @click="update(id)" v-if="data && data.status == 1">修改计划</el-button> 
			<el-button type="primary" :loading="downLoading" @click="cancelAction()" v-if="data && data.status == 1">取消计划</el-button>
			<el-button type="primary" @click="$refs.updateLog.show(data.id)">查看修改历史</el-button>
			<el-button @click="goBack()" >返 回</el-button>
		</div>
		<ops-edit ref="opsEdit" @onUpdate="getDetailData"></ops-edit>
		<update-log ref="updateLog"></update-log>
		<status-edit ref="statusEdit" @onUpdate="getDetailData"></status-edit>
		<user-detail-list ref="userDetailList"></user-detail-list>
    </div>
</template>
<script>
import OpsEdit from  "./components/OpsEdit.vue"
import UpdateLog from "./components/UpdateLog.vue"
import StatusEdit from "./components/StatusEdit.vue"
import UserDetailList from "./components/UserDetailList.vue"
export default {
    props: {
        id: {
            type: [Number, String],
            default: ""
        }
    },
    components:{
        OpsEdit,UpdateLog,StatusEdit,UserDetailList
    },
    data() {
        return {
            data: null,
            dataLoading: false,
            sswap: process.env.VUE_APP_SSWAP_URL,
            userData:null,
            userList: [],
            params: {
                pageNo: 1,
                pageSize: this.$pageSizes[0],
            },
            downLoading: false,
			cancelLoading:false,
			cancelUserLoading:false,
			redirect: this.$route.query.redirect || '',
        }
    },
    computed: {
        status() {
            return {
                1:'进行中', 2:'已完成', 3:'已取消'
            }
        },
        contentType() {
            return {
                1: '仅短视频', 2: '仅直播间', 3: '短视频和直播间'
            }
        }
    },
    mounted() {
        if (this.id) {
            this.getDetailData();
            this.getUserList();
        }
    },
    methods: {
		update(id){
		    this.$router.push({
		        path: `/promotion/ops/update/${id}`,
		        query: {
		            redirect: this.$utils.objArgs(
		                this.$router.currentRoute.path,
		                this.params
		            ),
		        },
		    });
		},
		//返回
		goBack() {
		    if (this.redirect) {
		        this.$router.push({
		            path: this.redirect,
		        });
		    } else {
		        this.$router.go(-1);
		    }
		},
        //获取详情
        getDetailData() {
            this.dataLoading = true;
            this.$request({
                url: "/activity/cps/oriented/detail",
                method: "POST",
                params: {
                    id: this.id
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        // 获取达人列表
        getUserList() {
            this.dataLoading = true;
            this.$request({
                url: "/activity/cps/oriented/userList",
                method: "POST",
                params: {
                    id: this.id,
        			...this.params
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.userData = result;                        
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getUserList();
        },
		//取消达人
		cancelUser(douyinId){
			this.$confirm('确定要取消达人吗?', '提示', {
			    type: 'warning',
			    center: true,
			    closeOnClickModal: false
			}).then(() => {
			    this.cancelUserLoading = true;
			    this.$request({
			        url: '/activity/cps/oriented/cancelTalent',
			        method: 'POST',
			        params: {
						douyinId:douyinId,
			            id: this.id
			        },
			    }).then(res => {
			        const { state, msg } = res.data;
			        if( state == 1 ){
			            this.getUserList();
			        }else{
			            this.$message.error(msg || '请求失败');
			        }
			    }).catch(() => {
			        this.$message.error('请求错误');
			    }).finally(() => {
			        this.cancelUserLoading = false;
			    });
			})
		},
		//取消计划
		cancelAction(){
			this.$confirm('确定要取消计划吗?', '提示', {
			    type: 'warning',
			    center: true,
			    closeOnClickModal: false
			}).then(() => {
			    this.cancelLoading = true;
			    this.$request({
			        url: '/activity/cps/oriented/cancel',
			        method: 'POST',
			        params: {
			            id: this.id
			        },
			    }).then(res => {
			        const { state, msg } = res.data;
			        if( state == 1 ){
			            this.getDetailData();
			        }else{
			            this.$message.error(msg || '请求失败');
			        }
			    }).catch(() => {
			        this.$message.error('请求错误');
			    }).finally(() => {
			        this.cancelLoading = false;
			    });
			})
		},
        //导出
        download(){
            this.downLoading = true;
            this.$request({
                url: "/activity/cps/oriented/downloadDetail",
                method: "POST",
                params: {
                    id: this.id,
                },
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1 ) {
                        this.$confirm('下载任务创建成功,可以在下载任务列表查看', '提示', {
                            confirmButtonText: '立即查看',
                            cancelButtonText: '稍后再看',
                            type: 'success',
                            center: true,
                            closeOnClickModal: false
                        }).then(() => {
                            this.$router.push({path:'/workbench/downloadList'})
                        }).catch(() => {})
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.downLoading = false;
                });
        },
    }
}
</script>
<style lang="scss" scoped>
.el-card__header {
    >div {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .el-button--text {
            padding: 0;
            font-size: 12px;
        }
    }
}
</style>